import React, { useEffect, useRef } from "react";
import { useAuth } from "../lib/auth";
import { ADSENSE_CLIENT, ADSENSE_SLOTS, pushAd } from "../lib/adsense";

/**
 * Reusable inline AdSense slot.
 * Renders nothing for Pro users or when AdSense env vars are not configured.
 *
 * Usage:
 *   <AdSlot slot="inline" format="auto" />
 *   <AdSlot slot="left" adSlotId="1234567890" style={{minHeight:600}} />
 */
export function AdSlot({
    slot = "inline",
    adSlotId,
    format = "auto",
    responsive = true,
    style,
    className = "",
    testId,
}) {
    const { user } = useAuth();
    const insRef = useRef(null);

    // Resolve slot id from env if not passed directly
    const resolvedSlot = adSlotId || ADSENSE_SLOTS[slot];

    useEffect(() => {
        if (!ADSENSE_CLIENT || !resolvedSlot) return;
        if (!insRef.current) return;
        pushAd();
    }, [resolvedSlot]);

    if (user?.is_pro) return null;
    if (!ADSENSE_CLIENT || !resolvedSlot) return null;

    return (
        <ins
            ref={insRef}
            className={`adsbygoogle ${className}`}
            style={{ display: "block", ...style }}
            data-ad-client={ADSENSE_CLIENT}
            data-ad-slot={resolvedSlot}
            data-ad-format={format}
            data-full-width-responsive={responsive ? "true" : "false"}
            data-testid={testId || `ad-slot-${slot}`}
        />
    );
}
